namespace HA {
    export class HAObject {
        protected data: Map<string, any>;

        /**
         *
         * @param data
         */
        public constructor(data?: any) {
            this.initialize(data);
        }

        public getElement(useTag?: boolean): Element | any {
            let element = this.get("element");
            if (!element) {
                const tag = this.getTag();
                if (tag && (useTag || !(tag instanceof HA.Core.HTML.Tag))) {
                    element = tag.getElement();
                }
            }

            return element;
        }

        public getTag(): HA.Core.HTML.Tag|HA.Core.HTML.Container| any {
            return this.get("tag");
        }

        /**
         *
         * @param tag
         * @returns {Map<String, any>}
         */
        public setTag(tag: HA.Core.HTML.Tag) {
            return this.addToData("tag", tag);
        }

        /**
         *
         * @param id
         * @returns {any}
         */
        protected get(id: any) {
            return this.getData().get(id);
        }

        protected remove(id: any): void {
            this.getData().delete(id);
        }

        /**
         *
         * @param id
         * @returns {boolean}
         */
        protected has(id: any) {
            return this.getData().has(id);
        }

        /**
         *
         * @param id
         * @returns {boolean}
         */
        protected hasNot(id: any): boolean {
            return !this.has(id);
        }

        protected getData(): Map<any, any> {
            if (!this.data) {
                this.data = new Map();
            }
            return this.data;
        }

        /**
         *
         * @returns ServiceManager
         */
        protected getServiceManager() {
            return this.get("services");
        }

        /**
         *
         * @param data
         */
        protected updateData(data: Map<any, any>) {
            const me = this;
            data.forEach((v: any, k: any) => {
                me.addToData(k, v);
            });
        }

        /**
         *
         * @param name
         * @param data
         * @returns {Map<String, any>}
         */
        protected addToData(name: any, data: any) {
            return this.getData().set(name, data);
        }

        /**
         *
         * @param data
         */
        protected initialize(data?: any) {
            if (data instanceof Map) {
                this.data = data;
            } else if (data instanceof Object) {
                    this.data = toMap(data);
            }

            const services = this.get("services");
            if (services && !(services instanceof ServiceManager)) {
                this.addToData("services", new ServiceManager(toMap(services)));
            }
        }

        /**
         *
         * @param services
         */
        protected addServices(services: Map<string, Function>) {
            return this.getServiceManager().addServices(services);
        }

        /**
         *
         * @param serviceName
         * @param func
         */
        protected addService(serviceName: string, func: Function) {
            return this.getServiceManager().addService(serviceName, func);
        }

        /**
         *
         * @param names
         * @returns {Map<string, Function>}
         */
        protected getServices(names: string[]) {
            return this.getServiceManager().getServices(names);
        }

        /**
         *
         * @param name
         * @returns {any}
         */
        protected getService(name: string) {
            return this.getServiceManager().getService(name);
        }
    }
}
